<template>
  <main class="journal-body" :class="{'sidebar-small': !showJournalSidebar}">
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </main>
</template>

<script>
  import {journalSidebar} from '../../../mixins/journalSidebar'
  export default {
    name: "journalBody",
    mixins: [journalSidebar]
  }
</script>

<style lang="scss" scoped>
  .journal-body {
    /*width: calc(100% - (240px + 260px));*/
    /*width: 1060px !important;
    padding: 50px 0;
    margin: 0 auto;
    padding-left: 260px;*/
    /*position: fixed;*/
    /*left: calc(240px + 260px);*/
    /*top: calc(90px + 70px);*/
    background-color: #EFF3F6;
    /*overflow-y: scroll;*/
    /*height: calc( 100vh - 160px );*/

    width: calc(100% - 260px);
    margin-left: auto;
    padding-top: 110px;
    transition: all .25s;

    /*@include scrollbal(5px);*/

    &.sidebar-small {
      width: calc(100% - 70px);
    }

    .text-with-line, .text-with-line-center {
      margin-bottom: 20px;
    }

    .text-with-line_blue-bg span {
      color: $darkBlue;
      font-family: $mm;
      font-weight: 500;
      font-size: 14px;
    }
  }

  .new-action, .view-action {
    margin-bottom: 10px;
    padding: 10px 30px 25px 30px;
    background: #FFFFFF;
    box-shadow: 0 4px 12px rgba(0, 82, 127, 0.2);
    border-radius: 8px;

    .action-head {
      padding-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #EFF3F6;
    }

    .input-cont {
      width: 180px;
    }

    .inputs {
      display: flex;
    }

    .inputs-item {
      display: flex;
      align-items: center;
      &:first-child {
        margin-right: 20px;
      }

      svg {
        margin-right: 5px;
      }
    }
  }

  .action-body {
    padding: 30px 0 25px 0;

    .body-heading {
      margin-bottom: 30px;
      color: $darkBlue;
      font-family: $msb;
      font-weight: 600;
      font-size: 24px;
    }

    .body-text {
      color: $darkBlue;
      font-family: $mm;
      font-weight: 500;
      font-size: 13px;
      line-height: 165%;
      padding-bottom: 30px;
      border-bottom: 1px solid #EFF3F6;
    }
  }

  .action-footer {
    display: flex;
    justify-content: flex-end;
  }
  .btn {
    max-width: 200px;
  }
  .btn-blue {
    margin-left: 20px;
  }

  .info-block {
    display: flex;
    justify-content: space-between;
    padding: 19px 30px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .delete-button {
    display: flex;
    align-items: center;
    color: $blue;
    font-family: $mm;
    font-weight: 500;
    font-size: 14px;
    svg {
      margin-left: 10px;
    }
  }

  .add-block {
    padding: 19px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: $mm;
    font-weight: 500;
    font-size: 14px;
    color: $blue;
    border: 1px dashed $blue;
    border-radius: 8px;
    svg {
      margin-right: 10px;
    }
  }

  .view-action {

  }

  .event-head {
    padding-top: 20px;
  }

  .item {
    .text {
      font-family: $mm;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
    }
    .event {
      color: $green;
    }
  }

</style>
